export default defineNuxtPlugin(() => {
  addRouteMiddleware((to) => {
    if (to.path === '/' || to.path.endsWith('/')) return true
    const { path, query, hash } = to
    const nextPath = path + '/' || '/'
    const nextRoute = { path: nextPath, query, hash }
    return navigateTo(nextRoute, { redirectCode: 301 })
  })
})
